export const quoteSpec = [
  { label: "Product", value: "3-in-1 Pill Crusher (option ①, the mold with ears)" },
  { label: "Size", value: '2.95" × 1.95" × 1.57"' },
  { label: "Stock plastic colors", value: "White, Blue, Pink" },
  { label: "Imprint", value: "UV print, full color, 1 location" },
  { label: "Packing", value: "1 pc per poly bag (no retail box)" },
];

export type QuoteRow = {
  qty: number;
  production: string;
  rates: { method: string; transit: string; unit: number; total: number }[];
};

export const quoteRows: QuoteRow[] = [
  {
    qty: 1000,
    production: "10–12 days",
    rates: [
      { method: "Express", transit: "4–5 days", unit: 1.92, total: 1920 },
      { method: "Slow air", transit: "14–15 days", unit: 1.75, total: 1750 },
      { method: "Sea", transit: "26–28 days", unit: 1.39, total: 1390 },
    ],
  },
  {
    qty: 3000,
    production: "25–30 days",
    rates: [
      { method: "Express", transit: "4–5 days", unit: 1.82, total: 5460 },
      { method: "Slow air", transit: "14–15 days", unit: 1.65, total: 4950 },
      { method: "Sea", transit: "26–28 days", unit: 1.28, total: 3840 },
    ],
  },
  {
    qty: 5000,
    production: "25–30 days",
    rates: [
      { method: "Express", transit: "4–5 days", unit: 1.73, total: 8650 },
      { method: "Slow air", transit: "14–15 days", unit: 1.58, total: 7900 },
      { method: "Sea", transit: "26–28 days", unit: 1.16, total: 5800 },
    ],
  },
];

export const quoteNotes = [
  "Full custom artwork needs at least 3,000 units. Under 3,000, they can only print on stock that already has cartoon designs on it.",
  "The quote is only valid for one week, so ask them to re-confirm before paying.",
  "China's National Day holiday runs Sept 25 – Oct 7, which is happening now. Expect slow replies and delays.",
  "Shipping is included to ONE US address. It excludes Hawaii, Alaska, Puerto Rico, and military addresses.",
];

export const renderVsReality = [
  {
    title: "The glowing eyes won't glow",
    text: "UV print is flat ink. It can make eyes look bright, but they won't light up, so market the renders as \"artwork\" or tone the glow down.",
  },
  {
    title: "Black, sage, neon lime and hot pink aren't stock plastic",
    text: "Stock is White, Blue, and Pink. Other body colors need either full-coverage print over white plastic or custom-colored plastic. Ask for the custom-plastic minimum order.",
  },
  {
    title: "One print location",
    text: "The quote covers one printed area. Designs that wrap onto the lid, ears, or both the top and clear sections may need a second location at extra cost.",
  },
];
